<template>
  <div id="app">
    <router-view v-if="alive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      alive: true,
    };
  },
  mounted() {
    // 手动 给 token
    // window.sessionStorage["token"] = "A0E36434ABEF5FC0";
    // window.sessionStorage["AppToken"] = "360eea5d-5c1b-4fd4-bbe2-0e03b22060e2";
  },
  methods: {
    reload() {
      this.alive = false;
      this.$nextTick(() => {
        this.alive = true;
      });
    },
  },
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/App.vue